export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12076.15500a7f.jpg";